import React, { useContext, Suspense, useEffect, useState, useCallback, useMemo } from 'react';
import { AppContext } from '../ContextApi/ContextApi';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import Loading from '../Loading/Loading';
import { basePath, formatDate, validatePhoneNumber } from '../Constants/constant';
import Swal from 'sweetalert2';
import RefreshButton from '../Usables/RefreshButton';
import PageBanner from '../Usables/PageBanner';
import Loader from '../Usables/Loader';
import NoRecords from '../Usables/NoRecords';
import CompanyRegistration from '../Usables/CompanyRegistration';
import InputField from '../Usables/InputField';
import BasicButton from '../Usables/Buttons';
import SortingTable from '../Usables/SortingTable';

function CompanyDetails(props) {
    const { index } = useParams();
    const { industry, setIndustry, apiHeaderJSON, user } = useContext(AppContext);
    const [allCompany, setAllCompany] = useState([]);
    const [companyRegisterModal, setCompanyRegisterModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingFilter, setLoadingFilter] = useState(false);    
    const [companyEdit, setCompanyEdit] = useState(false);
    const [errors, setErrors] = useState({});
    const [sortConfig, setSortConfig] = useState({ key: "company_name", direction: "asc" });
    const [pagination, setPagination] = useState({page: 1, totalRecords: "", totalPages: "", limit: 10});
    const [formData, setFormData] = useState({
        id: "",
        company_name: "",
        summary: "",
        industry: "",
        address: "",
        poc1_name: "",
        poc1_designation: "",
        poc1_phone_code: "",
        poc1_phone: "",
        poc2_phone_code: "",
        poc1_email: "",
        poc2_name: "",
        poc2_designation: "",
        poc2_phone: "",
        poc2_email: "",
        company_username: "",
        company_password: "",
        role_id: "",
    });
    const [filterData, setFilterData] = useState({company: "", industry: "",});

    const [ischanged, setIschanged] = useState({getListChanged: false})


    const getList = useCallback(async () => {
        try {
            const response = await axios.get(`${basePath}/getcompanybypage`,{
                 params: {
                    limit: 500,
                    page: 1,
                    filter: JSON.stringify(filterData),
                    id:localStorage.getItem("userId")
                },
                headers:apiHeaderJSON
            });
            // console.log("company==>>", response);
            setAllCompany(response?.data.data);
            setPagination({
                ...pagination,
                totalPages: response?.data?.pages,
                totalRecords: response?.data?.totalRecords
            });
            setLoading(false);
            setLoadingFilter(false);
        } catch (error) {
            console.log(error);
            setLoading(false);
            setLoadingFilter(false);
        }
    },[pagination, filterData]);

    useEffect(() => {  
        setLoading("1");      
        getList();
    }, []);

    useEffect(() => {
        if(ischanged?.getListChanged){
            // console.log("in getList");
            getList();
            setIschanged({ ...ischanged, getListChanged: false });
        }
    }, [ischanged?.getListChanged]);

    const handleExport = async () => {
        try {
            
            const response = await axios.get(`${basePath}/getcompanybypage?download=yes&filter=${JSON.stringify(filterData)}`, {
                responseType: 'blob', // Ensure response is treated as a blob
                headers:apiHeaderJSON
            });

            // Create a URL for the blob object
            const url = window.URL.createObjectURL(new Blob([response.data]));

            // Create a temporary <a> element to trigger the download
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Companies.xlsx');
            document.body.appendChild(link);
            link.click();

            // Clean up resources
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error exporting jobs:', error);
        }
    };

    const handleCompanySubmit = (e) => {
        setLoading("2");
        const options = {
            url: `${basePath}/companyregistration?recruiterId=${localStorage.getItem("userId")}`,
            method: "POST",
            headers: {
                ...apiHeaderJSON,
            },
            data: formData,
        }
        axios(options)
            .then((response) => {
                if (response.status === 200) {
                    setLoading(false);

                    setFormData({});
                    setIndustry("");
                    handleClose();

                    toast.success('Company registered Successfully!');
                }
                else {
                    toast.error('There is some issue with server!');
                }
            })
            .catch((error) => {
                setLoading(false);
                console.log("compnay create error", error);
                if (error.response) {
                    console.error("compnay create Response error:", error.response.status, error.response.data);
                    toast.error(error.response?.error || error.response?.data?.message || "Failed to create company");
                } else {
                    // Network or other error
                    console.error("Request error:", error.message);
                    toast.error("Network or unexpected error occurred.");
                }
            });


    }
    
    const handleSubmit = ()=> {
        const errorList = validateForm();
        console.log("errorList", errorList);
        if (Object.keys(errorList).length > 0) {
            setErrors(errorList);
            return;
        }
        Swal.fire({
        title: 'Are you sure?',
        text: `You want to ${formData?.id ? "update" : "save"} company details!`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `Yes, ${formData?.id ? "Update" : "Save"}!`,
        cancelButtonText: 'No, Cancel!',
        confirmButtonColor: '#1F1E30', 
        cancelButtonColor: '#F44336',
        allowOutsideClick:false,
        }).then((result) => {
            if (result.isConfirmed) {
                if(formData?.id){
                    handleSubmitEditForm();
                }
                else {
                    handleCompanySubmit();
                }
            }
        })
    }   

    useEffect(() => {
        if (industry) {
            setFormData({ ...formData, industry });
        }
    }, [industry]);

    const handleSubmitEditForm = (e) => {
        setLoading("2");
        const data = {
            ...formData,
            recruiter_id: localStorage.getItem("userId"),
        };
        // console.log("data", data);
        if (formData?.company_username && formData?.company_password &&
            formData?.id) {

            const options = {
                url: `${basePath}/updatecompany/${formData?.id}`,
                method: "PUT",
                headers: {
                    ...apiHeaderJSON,
                },
                data: data,
            }
            axios(options)
                .then((response) => {
                    if (response.status === 200) {
                        getList();
                        toast.success("Company Data Updated Successfully");
                        handleClose();
                    }
                    else {
                        toast.error("Failed to update company");
                    }
                    setLoading(false);
                })
                .catch((error) => {
                    setLoading(false);
                    console.log("compnay update error", error);
                    if (error.response) {
                        console.error("compnay update Response error:", error.response.status, error.response.data);
                        toast.error(error.response?.error || error.response?.data?.message || "Failed to update company");
                    } else {
                        // Network or other error
                        console.error("Request error:", error.message);
                        toast.error("Network or unexpected error occurred.");
                    }
                });
        }
        else {
            toast.error();
        }
    }

    const validateForm = ()=> {
        const errors = {};
        // Conpany details =================>>>>>>>>
        if (!formData?.company_name || formData?.company_name.trim() === "") {
            errors.company_name = "Name is required!";
            return errors;
        } else if (formData?.company_name.length < 3) {
            errors.company_name = "Name must be at least 3 characters!";
            return errors;
        } else if (!/^[A-Za-z\s]+$/.test(formData?.company_name)) {
            errors.company_name = "Name can only contain letters!";
            return errors;
        }
        if (!formData?.industry || formData?.industry.trim() === "") {
            errors.industry = "Industry is required!";
            return errors;
        }
        if (!formData?.summary || formData?.summary.trim() === "") {
            errors.summary = "Summary is required!";
            return errors;
        }
        if (!formData?.address || formData?.address.trim() === "") {
            errors.address = "Address is required!";
            return errors;
        }

        // Contact Persons Details ===================>>>>>>
        if (!formData?.poc1_name || formData?.poc1_name.trim() === "") {
            errors.poc1_name = "Name is required!";
            return errors;
        } else if (formData?.poc1_name.length < 3) {
            errors.poc1_name = "Name must be at least 3 characters!";
            return errors;
        } else if (!/^[A-Za-z\s]+$/.test(formData?.poc1_name)) {
            errors.poc1_name = "Name can only contain letters!";
            return errors;
        }
        if (!formData?.poc1_designation || formData?.poc1_designation.trim() === "") {
            errors.poc1_designation = "Name is required!";
            return errors;
        } else if (formData?.poc1_designation.length < 3) {
            errors.poc1_designation = "Name must be at least 3 characters!";
            return errors;
        }
        // mobile number validation
        if (!formData?.poc1_phone_code || formData?.poc1_phone_code.trim() === "") {
            errors.poc1_phone_code = "Required!";
            return errors;
        }
        if (!formData?.poc1_phone || formData?.poc1_phone.trim() === "") {
            errors.poc1_phone = "Mobile number is required!";
        } else if (formData?.phone_code && formData?.poc1_phone) {
            const validateNum = validatePhoneNumber(formData?.phone_code, formData?.poc1_phone);
            if(!validateNum?.isValid && validateNum?.codeError) {
                errors.phone_code = validateNum?.message;
                return errors;
            }
            else if(!validateNum?.isValid && !validateNum?.codeError) {
                errors.poc1_phone = validateNum?.message;
                return errors;
            }
        }
        // Email validation
        if (!formData?.poc1_email || formData?.poc1_email.trim() === "") {
            errors.poc1_email = "Email is required!";
            return errors;
        } else if (
            !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData?.poc1_email)
        ) {
            errors.poc1_email = "Invalid email address!";
            return errors;
        }

        if (formData?.poc2_name && formData?.poc2_name.length < 3) {
            errors.poc2_name = "Name must be at least 3 characters!";
            return errors;
        } else if (formData?.poc2_name && !/^[A-Za-z\s]+$/.test(formData?.poc2_name)) {
            errors.poc2_name = "Name can only contain letters!";
            return errors;
        }
        if (formData?.poc2_designation && formData?.poc2_designation.length < 3) {
            errors.poc2_designation = "Designation must be at least 3 characters!";
            return errors;
        }
        // mobile number validation
        if (formData?.phone_code && formData?.poc2_phone) {
            const validateNum = validatePhoneNumber(formData?.phone_code, formData?.poc2_phone);
            if(!validateNum?.isValid && validateNum?.codeError) {
                errors.phone_code = validateNum?.message;
                return errors;
            }
            else if(!validateNum?.isValid && !validateNum?.codeError) {
                errors.poc2_phone = validateNum?.message;
                return errors;
            }
        }
        // Email validation
        if (formData?.poc2_email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData?.poc2_email)) {
            errors.poc2_email = "Invalid email address!";
            return errors;
        }

        // Credentials =====================>>>>>>>>>
        if (!formData?.company_username || formData?.company_username.trim() === "") {
            errors.company_username = "Username is required!";
            return errors;
        } else if (formData?.company_username.length < 4) {
            errors.company_username = "Username must be at least 4 characters!";
            return errors;
        }
        if (!formData?.company_password || formData?.company_password.trim() === "") {
            errors.company_password = "Username is required!";
            return errors;
        } else if (formData?.company_password.length < 4) {
            errors.company_password = "Username must be at least 4 characters!";
            return errors;
        }
        return errors;
    }
    // console.log(allCompany);

    const handleClose = ()=> {;
        setCompanyEdit(false);
        setFormData({});
        setErrors({});
        setCompanyRegisterModal(false);
    }

    const handleChange = useCallback((event,id)=> {
        const {name, value} = event?.target;
        // console.log("name, value",name, value);
        setFormData({ ...formData, [name]: value, }); 
        setErrors({...errors, [name]: ""});
    },[formData, errors]);

    const handleEditOn = ()=> {
        setCompanyEdit(true);
    }

    // handling edit button 
    const handleEdit = (val) => {
        // console.log("edit val =>", val);
        setFormData({
            id: val?.id,
            company_name: val?.company_name,
            summary: val?.summary,
            industry: val?.industry,
            address: val?.address,
            poc1_name: val?.poc1_name,
            poc1_designation: val?.poc1_designation,
            poc1_phone: val?.poc1_phone,
            poc1_email: val?.poc1_email,
            poc2_name: val?.poc2_name,
            poc2_designation: val?.poc2_designation,
            poc2_phone: val?.poc2_phone,
            poc2_email: val?.poc2_email,
            company_username: val?.company_username,
            company_password: val?.company_password,
            role_id: val?.role_id,
        });
        // setCompanyEdit(true);
        setCompanyRegisterModal(val);
    }
    const handleCancelEdit = () => {
        setFormData({
            id: companyRegisterModal?.id,
            company_name: companyRegisterModal?.company_name,
            summary: companyRegisterModal?.summary,
            industry: companyRegisterModal?.industry,
            address: companyRegisterModal?.address,
            poc1_name: companyRegisterModal?.poc1_name,
            poc1_designation: companyRegisterModal?.poc1_designation,
            poc1_phone: companyRegisterModal?.poc1_phone,
            poc1_email: companyRegisterModal?.poc1_email,
            poc2_name: companyRegisterModal?.poc2_name,
            poc2_designation: companyRegisterModal?.poc2_designation,
            poc2_phone: companyRegisterModal?.poc2_phone,
            poc2_email: companyRegisterModal?.poc2_email,
            company_username: companyRegisterModal?.company_username,
            company_password: companyRegisterModal?.company_password,
            role_id: companyRegisterModal?.role_id,
        });
        setCompanyEdit(false);
    }

    const handleChangeFilter = useCallback((event)=> {
        const {name, value} = event?.target;
        setFilterData({ ...filterData, [name]: value, });
        // it will call getList after defined time (delay)
        // debounceGetList();        
    },[filterData]);

    const handleFilter = useCallback(()=>{ 
        setLoadingFilter("1"); 
        getList();
    },[getList]);

    const handleClear = useCallback(()=> {
        setLoadingFilter("2");
        setFilterData({company: "", industry: "",});
        setIschanged({...ischanged, getListChanged:true});
    },[ischanged]);


  const sortedData = useMemo(() => {
    const sortableData = [...allCompany];

    if (sortConfig.key && sortConfig.direction) {
        sortableData.sort((a, b) => {
            const aVal = a[sortConfig.key] ?? "";
            const bVal = b[sortConfig.key] ?? "";
            if (typeof aVal === "string" && typeof bVal === "string") {
                return sortConfig.direction === "asc"
                ? aVal.localeCompare(bVal)
                : bVal.localeCompare(aVal);
            }

            // fallback for numbers/dates
            if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1;
            if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1;
            return 0;
        });

    }
    return sortableData;
  }, [allCompany, sortConfig]);

  const requestSort = (key) => {
    let direction = "asc";

    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    } else if (sortConfig.key === key && sortConfig.direction === "desc") {
      direction = "asc";
      key = "company_name";
    }

    setSortConfig({ key, direction });
  };

    return (
        <Suspense fallback={<Loading />}>
            <section className='lightBabyGreen baseHeightWidth customScroll mb-5'>
                {/* RefreshButton => used for refresh table data */}
                <RefreshButton onClick={getList} position='fixed' />
                <div className='customScroll'>
                    {/* PageBanner => used to show page banner info */}
                    <PageBanner pageName='Company' pageTitle='Ready to start your day' src='/img/registration.png' alt="Company" />
                    {companyRegisterModal &&
                        (<CompanyRegistration
                            data={formData}
                            errors={errors}
                            OnlyView={!user[index]?.edit_access}
                            loading={loading === "2"}
                            disabled={!companyEdit}
                            onClose={handleClose}
                            onChange={handleChange}
                            onEdit={handleEditOn}
                            onCancel={handleCancelEdit}
                            onSubmit={handleSubmit}
                        />)
                    }
                    <div className=' grid lg:grid-cols-5 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 items-center gap-3 grayBlurShadow bg-white p-3 mt-5 mb-3 rounded-xl'>
                        {user[index]?.add_access &&
                            (<button  onClick={(e) => {setCompanyRegisterModal(true); setCompanyEdit(true);}}
                            className='darkPurple w-fit ml-2 cursor-pointer rounded-full py-2 px-3 text-white flex items-center gap-2 font-bold grayBlurShadow hoverGreen navAnimation'>
                                <img className=' w-8 ' src="/img/addBtn.png" alt="Add new company" />
                                Add New Company
                            </button>)
                        }
                        <InputField  id="company" name="company" type="text" label="Company:"
                            placeholder="Enter Company"
                            disabled={loading === '1'}
                            value={filterData?.company}
                            onChange={handleChangeFilter}
                        />
                        <InputField  id="industry" name="industry" type="text" label="Industry:"
                            placeholder="Enter Industry"
                            disabled={loading === '1'}
                            value={filterData?.industry}
                            onChange={handleChangeFilter}
                        />
                        <div className="flex gap-3 col-span-1">
                            <div className=" flex flex-col">
                                <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Apply Filter</label>
                                <BasicButton onClick={handleFilter} buttonName='Apply Filter' className='darkPurple text-nowrap' shadow={true}
                                disabled={loading || loadingFilter || (!filterData?.company && !filterData?.industry)} 
                                loading={loadingFilter === "1"} loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hoverGreen" />
                            </div>
                            <div className=" flex flex-col">
                                <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Clear Filter</label>
                                <BasicButton onClick={handleClear} buttonName='Clear Filter' className="bg-red-600 text-nowrap" shadow={true}
                                disabled={loading || loadingFilter || (!filterData?.company && !filterData?.industry)} 
                                loading={loadingFilter === "2"} loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hover:bg-red-900" />
                            </div>
                            <div className=" flex flex-col">
                                <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Excel Export</label>
                                <BasicButton onClick={handleExport} buttonName='Excel' className="bg-green-800 text-nowrap" shadow={true}
                                disabled={loading || loadingFilter || (Array.isArray(allCompany) && allCompany?.length === 0) } 
                                loading={loadingFilter === "3"} loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hover:bg-green-950" />
                            </div>
                        </div>
                    </div>
                    {loading === "1" ?
                        <Loader/> :
                        Array.isArray(allCompany) && allCompany?.length >= 1 ?
                        <section className='bg-white grayBlurShadow px-7 pt-7 mt-2 pb-5 rounded-3xl mb-8'>
                            <div className=' overflow-auto tableBody'>
                                <table className=' navAnimation rounded-2xl baseWidth text-left'>
                                    <thead className=' text-lg tableHead'>
                                        <tr className="bg-gray-200">
                                            <th className="text-center">Sr.No.</th>
                                            <th className="text-center cursor-pointer" onClick={() => requestSort("created_at")}>
                                                <div className='flex items-center justify-center gap-1'>
                                                    Created Date {<SortingTable sortConfig={sortConfig} tHead="created_at" />}
                                                </div>
                                            </th>
                                            <th className="cursor-pointer" onClick={() => requestSort("company_name")}>
                                                <div className='flex items-center gap-1'>
                                                    Company {<SortingTable sortConfig={sortConfig} tHead="company_name" />}
                                                </div>
                                            </th>
                                            <th className="cursor-pointer" onClick={() => requestSort("poc1_name")}>
                                                <div className='flex items-center gap-1'>
                                                    Contact Person {<SortingTable sortConfig={sortConfig} tHead="poc1_name" />}
                                                </div>
                                            </th>
                                            <th className="cursor-pointer" onClick={() => requestSort("industry")}>
                                                <div className='flex items-center gap-1'>
                                                    Industry {<SortingTable sortConfig={sortConfig} tHead="industry" />}
                                                </div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody className='tableBody '>
                                        {
                                            Array.isArray(sortedData) && sortedData?.map((val, idx) => {
                                                return (
                                                    <tr key={val?.id} id={val?.id} className=' backWhite font-semibold text-sm'>
                                                        <td className=' whitespace-nowrap text-center'>{idx+1}</td>
                                                        <td className=' whitespace-nowrap text-center'>{val?.created_at ? formatDate(val?.created_at) : "--"}</td>
                                                        <td>
                                                            <span className={`line-clamp-1 text-ellipsis text-blue-900 ${val?.company_name && (user[index]?.view_access || user[index]?.edit_access) && "hover:text-blue-700 hover:underline transition-all duration-150 ease-in-out cursor-pointer"}`} onClick={()=> {if (val?.company_name && (user[index]?.view_access || user[index]?.edit_access)) handleEdit(val)}}>{val?.company_name || "--"}</span>
                                                        </td>
                                                        <td className=' whitespace-nowrap'>{val?.poc1_name}</td>
                                                        <td className=' whitespace-nowrap'>{val?.industry}</td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                            {/* <Pagination disabled={loading === "3"} onLimitChange={handleLimit} onPrevChange={handlePrev} onNextChange={handleNext}
                            limit={pagination?.limit} totalRecords={pagination?.totalRecords} allPages={pagination?.totalPages} page={pagination?.page}
                            disabledPrev={pagination?.page === 1} disabledNext={pagination?.page === pagination?.totalPages}
                            /> */}
                        </section> :
                        <NoRecords/>
                    }


                </div >
            </section >
        </Suspense>
    );
}

export default CompanyDetails;
